import React from 'react';
import { Marker } from 'react-leaflet';
import { getIconStatus } from 'src/app/utils/vehicleService';
import RotateIcon from 'src/app/utils/RotateIcon';
import mkIcon from '../../assets/mkicon.png';

const handleDisplayIcon = (vehicle) => {
  if (!vehicle) {
    return L.icon({
      iconUrl: '/static/iconSvg/cars/car_lost_gsm.svg',
      iconAnchor: [0, 0],
    });
  }

  if (vehicle.debt) {
    return L.icon({
      iconUrl: '/static/iconSvg/motors/motor_expired.svg',
      iconAnchor: [16, 16],
    });
  }

  const iconVehicle = getIconStatus(vehicle.device_status, vehicle.vehicle_type);
  let iconObject = RotateIcon.makeIcon(iconVehicle);

  if (typeof iconObject.setRotation === 'function') {
    iconObject = iconObject.setRotation({
      deg: vehicle.direction || 0.001,
    });
  }

  const url = typeof iconObject.getUrl === 'function' ? iconObject.getUrl() : mkIcon;
  const validUrl = url?.startsWith('data:image') ? url : iconVehicle;

  return L.icon({
    iconUrl: validUrl,
    iconAnchor: [16, 16],
  });
};

const VehicleMarker = React.forwardRef(
  ({ vehicle, position, isSelected, onClick, markerRef, vehicleIconsRef, opacity, children }, ref) => {
    const icon = handleDisplayIcon(vehicle);

    return (
      <Marker
        position={position}
        icon={icon}
        zIndexOffset={isSelected ? 1000 : 0}
        opacity={opacity}
        eventHandlers={{ click: () => onClick(vehicle) }}
        ref={(r) => {
          if (r) {
            markerRef.current[vehicle.device_id] = r;

            if (!vehicleIconsRef.current[vehicle.device_id]) {
              vehicleIconsRef.current[vehicle.device_id] = icon;
            }
          }

          if (ref) ref(r);
        }}
      >
        {children}
      </Marker>
    );
  }
);

export default React.memo(VehicleMarker);
